module.exports = __webpack_public_path__ + "pic_bizny_web_04@2x.png?1a715ce32839ec8fd684cb41bf978a07";